import { LockOutlined } from '@ant-design/icons';
import { PageHeader } from '@ant-design/pro-components';
import { Alert } from 'antd';
import type React from 'react';
import { useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { MainContent } from '../../components/MainContent.tsx';
import { useCurrentContextStore } from '../../hooks/store/useCurrentContextStore.ts';
import { useDoctorEcardEnabled } from '../../hooks/useDoctorEcardEnabled.ts';
import { hasSomeRole, Role } from '../../utils/user.ts';
import { EcardConfigs } from './ecard/EcardConfigs.tsx';
import { EcardSetupAssistant } from './ecard/EcardSetupAssistant.tsx';

export const Ecard: React.FC = () => {
  const [showAssistant, setShowAssistant] = useState(false);
  const auth = useAuth();
  const isUserRole = hasSomeRole([Role.ROLE_LR_USER], auth.user);
  const { currentDoctorId, primaryDoctorId } = useCurrentContextStore();
  const doctorId = isUserRole ? currentDoctorId : primaryDoctorId;
  const ecardEnabled = useDoctorEcardEnabled(doctorId);

  if (!ecardEnabled) {
    return (
      <MainContent size="medium">
        <PageHeader title="e-card Einstellungen" />
        <Alert
          type="info"
          icon={<LockOutlined />}
          showIcon
          title="Die e-card Integration ist nicht aktiviert"
          description={
            <>
              <p>
                Mit der e-card Integration können Sie diverse Services der Sozialversicherung nutzen, wie z.B. die Abfrage des
                Versicherungsstatus von Patienten, oder die automatische Vervollständigung von Patientendaten bei der manuellen
                Patienteneingabe.
              </p>
              <p>Bitte kontaktieren Sie Ihr Labor bei Interesse an dieser Funktion.</p>
            </>
          }
        />
      </MainContent>
    );
  }

  if (!window.nativeApi) {
    return (
      <MainContent size="medium">
        <PageHeader title="e-card Einstellungen" />
        <Alert
          type="info"
          showIcon
          title="Diese Funktion steht im Web-Browser nicht zur Verfügung. Sie müssen unseren Desktop-Client verwenden, um die e-card Integration verwenden zu können."
        />
      </MainContent>
    );
  }

  if (showAssistant) {
    return <EcardSetupAssistant onHideAssistant={() => setShowAssistant(false)} />;
  }
  return <EcardConfigs onShowAssistant={() => setShowAssistant(true)} />;
};
